// Ausgeblendeter Beispieldaten-Hinweis. Liegt bewusst nur im Speicher, ein
// Reload zeigt den Hinweis wieder (sessionStorage würde den Reload
// überleben). Gilt für alle Listen eines Partners, auch über Seitenwechsel.
let dismissedPartnerId = null
const listeners = new Set()

const emit = () => listeners.forEach((listener) => listener())

export const subscribeSampleDataHint = (listener) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export const getDismissedSampleDataHintPartnerId = () => dismissedPartnerId

export const dismissSampleDataHint = (partnerId) => {
  if (!partnerId || dismissedPartnerId === partnerId) return

  dismissedPartnerId = partnerId
  emit()
}

// Nach dem Hinzufügen neuer Beispieldaten erklärt der Hinweis sie wieder
export const resetSampleDataHintDismissal = () => {
  if (dismissedPartnerId === null) return

  dismissedPartnerId = null
  emit()
}
